import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';
import React from 'react';
import colors from '../../theme/colors';

export type TestStatus =
  | 'ALL'
  | 'APPROVED'
  | 'COMPLETED'
  | 'INCOMPLETE'
  | 'SCHEDULED'
  | 'NOT_SCHEDULED';

const testStatusOptions = [
  {
    value: 'APPROVED',
    label: 'Approved',
    color: colors.statusSuccess,
  },
  {
    value: 'COMPLETED',
    label: 'Completed',
    color: colors.statusPending,
  },
  // {
  //   value: 'INCOMPLETE',
  //   label: 'Incomplete',
  // },
  {
    value: 'SCHEDULED',
    label: 'Scheduled',
    color: colors.primary,
  },
  {
    value: 'NOT_SCHEDULED',
    label: 'Not Scheduled',
    color: colors.statusError,
  },
] as const;

export const AssemblyTestStatusPicker = ({
  value,
  onChange,
}: {
  value?: TestStatus[];
  onChange: (value?: TestStatus[]) => void;
}) => {
  const selectedValues = testStatusOptions.filter((option) =>
    value?.includes(option.value)
  );

  return (
    <ReactSelect
      placeholder="test status"
      isMulti
      isClearable={false}
      value={selectedValues}
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '160px',
        }),
        multiValue: formatDotStyles,
      }}
      formatOptionLabel={formatDotLabel}
      onChange={(values) => {
        if (Array.isArray(values)) {
          onChange(
            values.length > 0 ? values.map((value1) => value1.value) : undefined
          );
        } else {
          onChange(undefined);
        }
      }}
      options={testStatusOptions}
    />
  );
};
